// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"PageHeader__subtitleContainer___uU8o8","dot":"PageHeader__dot___pwR5x","skeleton-loading":"PageHeader__skeleton-loading___L0pHv"};